import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { FOOD_MAIN_PAGE } from "utils/constants/paths";

const FoodMainPage = Loadable(React.lazy(() => import("./View")));

export const FoodMainPageRoute: IRouteItem = {
  path: FOOD_MAIN_PAGE,
  element: React.createElement(FoodMainPage),
  name: "Food ",
};
